// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let ImageUtils = require("../../../reason/common/imageUtils/ImageUtils.bs.js");
let ReasonPromise = require("../../../reason/ReasonPromise.bs.js");
let ReactImageCrop = require("../../bindings/ReactImageCrop.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function makeInitialCrop(image) {
  let widthPct = image.width < image.height ? 80 : image.height / image.width * 80;
  let heightPct = image.width > image.height ? 80 : image.width / image.height * 80;
  return {
    unit: "%",
    x: 5,
    y: 5,
    aspect: 1.0,
    width: widthPct,
    height: heightPct
  };
}

function CropProfilePhoto(props) {
  let onCropURLChange = props.onCropURLChange;
  let imageURL = props.imageURL;
  let match = React.useState(() => {});
  let setCrop = match[1];
  let match$1 = React.useState(() => {});
  let setCropURL = match$1[1];
  let cropURL = match$1[0];
  let onCropChange = crop => ReasonPromise.getOk(Utils__Promise.fromJsPromise(ImageUtils.getCroppedImage(imageURL, crop)), dataUrl => {
    setCropURL(param => dataUrl);
    onCropURLChange(dataUrl);
    if (cropURL !== undefined) {
      URL.revokeObjectURL(cropURL);
      return;
    }
  });
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ReactImageCrop.make, {
      src: imageURL,
      crop: match[0],
      onImageLoaded: image => {
        let crop = makeInitialCrop(image);
        setCrop(param => makeInitialCrop(image));
        onCropChange(crop);
        return false;
      },
      onChange: (param, pctCrop) => setCrop(param => pctCrop),
      onComplete: (param, pctCrop) => {
        setCrop(param => pctCrop);
        onCropChange(pctCrop);
      },
      minWidth: 20,
      minHeight: 20,
      keepSelection: true,
      circularCrop: true
    }),
    className: "flex items-center justify-center max-h-[520px] bg-zinc-200 [&_img]:max-h-[450px]"
  });
}

let make = CropProfilePhoto;

exports.makeInitialCrop = makeInitialCrop;
exports.make = make;
/* react Not a pure module */
